export type NavItem = {
  label: string
  /** Route path for pages, or an in-page anchor on the homepage. */
  to: string
  kind: 'route' | 'section'
}

export const navItems: NavItem[] = [
  { label: 'Home', to: '/', kind: 'route' },
  { label: 'Our Solutions', to: '/#solutions', kind: 'section' },
  { label: 'Portfolio', to: '/portfolio', kind: 'route' },
  { label: 'Comparison', to: '/#comparison', kind: 'section' },
  { label: 'Pricing Plan', to: '/pricing-plan', kind: 'route' },
]
